import React from "react"
import {Modal,ModalFooter,ModalBody,ModalHeader} from "reactstrap"

const CancelModal = ({modal,toggle,btnOne,btnTwo ,btnOneClick,btnTwoOclick}) => {
    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader>
                Warning
                </ModalHeader>
            <ModalBody>
                un submited data will not saved please complete the form and submit it
                  </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
                {/* <button className="btn btn-light w-25" onClick={btnOneClick}>{btnOne}</button>
                <button className="btn btn-primary w-25" onClick={btnTwoOclick}>{btnTwo}</button> */}

                 <button
                    className="btn btn-light px-3"
                    onClick={btnOneClick}
                >
                    {btnOne}
                </button>
                <button
                    className="btn btn-primary"
                    onClick={btnTwoOclick}
                >
                    {btnTwo}
                </button>
            </ModalFooter>
        </Modal>
    ) 
}

export default CancelModal